/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Cancelled_Description1Inputs */

const en_coinvestments_report_cancelled_description1 = /** @type {(inputs: Coinvestments_Report_Cancelled_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A report cannot be generated for a cancelled deal.`)
};

/**
* | output |
* | --- |
* | "A report cannot be generated for a cancelled deal." |
*
* @param {Coinvestments_Report_Cancelled_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_cancelled_description1 = /** @type {((inputs?: Coinvestments_Report_Cancelled_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Cancelled_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_cancelled_description1(inputs)
});
export { coinvestments_report_cancelled_description1 as "coInvestments_report_cancelled_description" }